<template>
    <div>
        <el-form ref="ruleForm" label-width="70px" class="demo-ruleForm">
            <el-form-item label="售卖加料">
                <div class="allattrs">
                    <div class="attr1" v-for="(item, index) in specList" :key="index">
                        <div class="attr1-left">
                            <div class="attr1-left1">
                                <div>加料名称</div>
                                <el-input :disabled="status" placeholder="请输入内容" v-model="item.attachName"></el-input>
                            </div>
                            <div class="attr1-left1">
                                <div>价格</div>
                                <el-input :disabled="status" placeholder="" v-model="item.price">
                                    <template slot="append">元</template>
                                </el-input>
                            </div>
                            <div class="attr1-left1">
                                <div>库存</div>
                                <el-input :disabled="status" style="width: 140px;" placeholder="" v-model="item.stockSize">
                                    <template slot="append">件</template>
                                </el-input>
                            </div>
                            <div class="attr1-left1">
                                <div style="height: 39px;"></div>
                                <el-checkbox :disabled="status" :true-label="1" :false-label="0" v-model="item.resetNextday" label="次日置满" border></el-checkbox>
                            </div>
                        </div>
                        <div class="attr1-right">
                            <el-button :disabled="status" type="text" icon="el-icon-remove-outline" @click="deleteList(index)">删除</el-button>
                        </div>
                    </div>
                    <div class="attrs-add" @click="addList()"><i class="el-icon-circle-plus" style="margin-right: 5px"></i>添加规格</div>
                    <div class="bor_b_df5 boxfor"></div>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            specList: [],
            status: false
        }
    },
    methods:{
        deleteList(index){
            this.specList.splice(index, 1)
        },
        addList(){
            this.specList.push({
                attachName: '',
                price: '',
                packPrice: '',
                stockSize: '',
                stockReset: '',
                resetNextday: 0
            })
        },
        init(val){
            this.$nextTick(()=>{
                this.specList = val
            })
        },
        setStatus(){
            this.$nextTick(()=>{
                this.status = true
            })
        },
    }
}
</script>

<style scoped lang="scss">
.left{
    font-size: 14px;
}
.allattrs{
    width: 100%;
    height: auto;
    .attr1{
        width: 100%;
        display: flex;
        margin-bottom: 30px;
        .attr1-left{
            display: flex;
            font-size: 14px;
            color: #666;
            .attr1-left1{
                width: 130px;
                margin-right: 15px;
            }
        }
        .attr1-right{
            display: flex;
            align-items: center;
            font-size: 12px;
        }
    }
    .attrs-add{
        color: #2d8cf0;
        cursor: pointer;
        width: 80px;
    }
    .boxfor {
        width: 70%;
        padding-bottom: 20px;
        margin-left: 3%;
    }
    .bor_b_df5{
        border-bottom: 1px solid #ebeef5;
    }
}
</style>